module.exports = __webpack_public_path__ + "static/media/user-details.5580d342.svg";